import { AuthLayout } from "./auth-layout";
import { FullPageSpinner } from "@edgelogistics/web-ui";
import { Suspense } from "react";
import { lazy } from "@utils/lazy-imports";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

const { Login } = lazy(
  () => import(/* webpackChunkName: "login" */ "@screens/login"),
  "Login"
);

const { RecoverAccount } = lazy(
  () =>
    import(
      /* webpackChunkName: "recover-account", webpackPrefetch: true */ "@screens/recover-account"
    ),
  "RecoverAccount"
);

export const UnauthenticatedApp = (): React.ReactElement => {
  const { pathname } = useLocation();

  return (
    <AuthLayout>
      <Suspense
        fallback={
          <FullPageSpinner
            classNames={{
              container: "absolute top-0 left-0 w-100vw h-100vh",
            }}
          />
        }
      >
        <Routes>
          <Route path={"/login"} element={<Login />} />
          <Route path={"/recover-account"} element={<RecoverAccount />} />
          {/* Save the not found pathname, to redirect the user once is logged in */}
          <Route
            path="*"
            element={<Navigate to={"/login"} state={{ pathname }} />}
          />
        </Routes>
      </Suspense>
    </AuthLayout>
  );
};
